import { useEffect, useState } from 'react';
import { business } from '../lib/api';
import { IndianRupee, TrendingUp, Package, Award } from 'lucide-react';

export default function BusinessWidget() {
  const [data, setData] = useState(null);

  useEffect(() => {
    business.revenue().then(setData).catch(() => setData(null));
  }, []);

  if (!data) return (
    <div className="card-soft p-5 text-sm text-ink/60">Loading business data…</div>
  );

  const bands = [
    { label: 'Today', amt: data.today_inr, orders: data.today_orders, color: 'text-[#D35400] bg-[#FFF3E0]' },
    { label: 'Last 7d', amt: data.week_inr, orders: data.week_orders, color: 'text-[#0D47A1] bg-[#E3F2FD]' },
    { label: 'Last 30d', amt: data.month_inr, orders: data.month_orders, color: 'text-[#1B5E20] bg-[#E8F5E9]' },
    { label: 'Lifetime', amt: data.lifetime_inr, orders: data.lifetime_orders, color: 'text-ink bg-muted' },
  ];

  return (
    <div data-testid="business-widget" className="space-y-5">
      <div className="flex items-start gap-3 flex-wrap">
        <div className="w-12 h-12 rounded-xl bg-[#E3F2FD] text-[#0D47A1] grid place-items-center shrink-0"><TrendingUp className="w-6 h-6"/></div>
        <div className="flex-1 min-w-[200px]">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-[#0D47A1]">Business on BharatCart</div>
          <h2 className="font-heading font-black text-2xl">Aap ne kitna kamaya?</h2>
          <p className="text-xs text-ink/60 mt-0.5">All paid + COD orders received through BharatCart, excluding cancellations.</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {bands.map((b, i) => (
          <div key={b.label} data-testid={`business-band-${i}`} className="card-soft p-4">
            <div className={`w-10 h-10 rounded-xl grid place-items-center ${b.color}`}><IndianRupee className="w-4 h-4"/></div>
            <div className="mt-2 text-[10px] uppercase tracking-[0.2em] font-bold text-ink/50">{b.label}</div>
            <div className="font-heading font-black text-2xl mt-0.5">₹{b.amt.toLocaleString('en-IN', { maximumFractionDigits: 0 })}</div>
            <div className="text-xs text-ink/60 mt-0.5">{b.orders} orders</div>
          </div>
        ))}
      </div>

      <div className="card-soft p-5">
        <div className="flex items-center gap-2 mb-3">
          <Award className="w-4 h-4 text-[#D35400]"/>
          <div className="font-heading font-bold text-base">Top 5 sellers (30 days)</div>
        </div>
        {data.top_items.length === 0 ? (
          <div className="text-sm text-ink/50 py-4">No sales yet in the last 30 days.</div>
        ) : (
          <div className="space-y-2">
            {data.top_items.map((t, i) => (
              <div key={`${t.product_id}-${i}`} data-testid={`business-top-${i}`} className="flex items-center gap-3 rounded-lg border border-border bg-white p-3">
                <div className="w-8 h-8 rounded-full bg-[#FFF3E0] text-[#D35400] grid place-items-center font-bold text-sm">{i + 1}</div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-sm truncate flex items-center gap-1"><Package className="w-3 h-3 text-ink/40"/>{t.name}</div>
                  <div className="text-xs text-ink/60">{t.quantity_30d} sold</div>
                </div>
                <div className="font-bold text-sm">₹{t.revenue_30d.toLocaleString('en-IN', { maximumFractionDigits: 0 })}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
